<template>
    <modal
    name="download-export-reports"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="960"
    height="auto"
    @before-open="getData"
    >
        <div class="modalWrapper">
            <div class="content_box">
                <div class="content_box_header">
                    <div class="d-flex justify-content-between">
                    <p class="text-white txt--ss opacity--50">Exported Reports</p>
                    <a href="javascript:void(0);" class="text-muted txt--ss" @click="getData"><i class="fas fa-sync" v-bind:class="{'fa-spin': get_report }"></i></a>
                    </div>

                </div>
                 <div class="content__divider"></div>
                  <div class="content__box__body">
                       <div class="form-row align-items-center mb-2">
                            <div class="col-sm-8 mb-1">
                                <p class="txt--off-white txt--ss txt--semi-bold mr-3">
                                Report Name
                                </p>
                            </div>
                            <div class="col-sm-2 mb-1">
                                <p class="txt--off-white txt--ss txt--semi-bold mr-3">
                               Progress
                                </p>
                            </div>                            
                            <div class="col-sm-2 mb-1">
                                <p class="txt--off-white txt--ss txt--semi-bold mr-3">
                                Actions
                                </p>
                            </div>
                       </div>

                        <div class="form-row mb-2" v-for="(report,index) in reports" :key="index">
                            <div class="col-md-8">
                                <p class="txt--ss">{{report.zip_name.replace("/","")}}</p>
                            </div>
                            <div class="col-md-2">
                                <p class="txt--ss" v-if="report.failed">Failed</p>
                                <p class="txt--ss" v-else-if="!report.zip_created">{{ report.total_space_list_created_with_overview}}/{{report.total_report}} </p>
                                <!-- <p class="txt--ss" v-else-if="report.total_space_list_created_with_overview ==report.total_report ">Zip Creating</p> -->
                                 <p class="txt--ss" v-else-if="report.zip_created">Zip Created </p>
                            </div>
                            <div class="col-md-2">
                                <a v-if="report.zip_created" :href="report.zip_file" class="txt--primary txt--ss" download>Download</a>
                                <a href="#" class="txt--primary txt--ss">
                                    <i class="fas fa-trash pl-2 txt--red" @click="confirmDeleteExport(report.export_id)"></i>
                                </a>
                            </div>
                        </div>
                  </div>
            </div>
        </div>
    </modal>
</template>
<script>
import axios from "../../axios";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
    name: "ExportReports",
    components: {},
    data() {
        return {
            reports: [],
            get_report: false,
        }
    },
    methods: {
        getData() {
            this.get_report = true;
            this.axios.post(window.hostname + "api/auth/download-exported-report", {
                //
            }).then((res) => {
                if (res.data.status) {
                    this.reports = res.data.data;
                }
                
                this.get_report = false;
            }).catch((error) => {
                console.log(error);
                
                this.get_report = false;
            });
        },
        confirmDeleteExport(export_id) {
            this.$swal({
                title: "Delete Export",
                text: "Are you sure you want to delete this export?",
                showCancelButton: true,
            }).then((result) => {
                if (result.value) {
                    this.deleteExport(export_id);
                }
            });
        },
        deleteExport(export_id) {
            this.get_report = true;
            this.axios.post(window.hostname + "api/auth/delete-exported-report", {
                'export_id': export_id,
            }).then((res) => {
                if (res.data.status) {
                    this.$toasted.show(res.data.message,{
                        icon: 'check-circle',
                        className: 'success-class'
                    });
                } else {
                    this.$toasted.show(res.data.message,{
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                }

                this.getData();
            }).catch((error) => {
                console.log(error);
                
                this.get_report = false;
            });
        }
    }
};
</script>
